export const getSubDomain = () => {
    const hostName = window.location.hostname
    switch (hostName) {
        case "test.profitfarmers.com":
        case "beta.profitfarmers.com":
            return true
        default:
            return false
    }
}